// frontend/src/components/contacts/ContactList.js
import React from 'react';

const emptyContact = () => ({
  firstName: '', lastName: '', title: '', workPhone: '', homePhone: '', email: '', mobilePhone: ''
});

function ContactList({ contacts, onChange, error }) {
  const addContact = () => onChange([...contacts, emptyContact()]);

  const removeContact = (index) => {
    if (contacts.length > 1) onChange(contacts.filter((_, i) => i !== index));
  };

  const updateContact = (index, field, value) => {
    const next = [...contacts];
    next[index] = { ...next[index], [field]: value };
    onChange(next);
  };

  return (
    <div className="contacts-section">
      {contacts.map((contact, index) => (
        <div className="contact-entry" key={index}>
          <div className="contact-header">
            <h4>Contact {index + 1}</h4>
            {contacts.length > 1 && (
              <button type="button" className="btn btn-danger btn-sm" onClick={() => removeContact(index)}>
                <i className="fas fa-times"></i>
              </button>
            )}
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>First Name <span className="required">*</span></label>
              <input type="text" className="form-control" value={contact.firstName || ''}
                onChange={(e) => updateContact(index, 'firstName', e.target.value)} placeholder="First name" />
            </div>
            <div className="form-group">
              <label>Last Name</label>
              <input type="text" className="form-control" value={contact.lastName || ''}
                onChange={(e) => updateContact(index, 'lastName', e.target.value)} placeholder="Last name" />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Title</label>
              <input type="text" className="form-control" value={contact.title || ''}
                onChange={(e) => updateContact(index, 'title', e.target.value)} placeholder="Job title" />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" className="form-control" value={contact.email || ''}
                onChange={(e) => updateContact(index, 'email', e.target.value)} placeholder="email@example.com" />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Work Phone</label>
              <input type="tel" className="form-control" value={contact.workPhone || ''}
                onChange={(e) => updateContact(index, 'workPhone', e.target.value)} placeholder="Work phone" />
            </div>
            <div className="form-group">
              <label>Home Phone</label>
              <input type="tel" className="form-control" value={contact.homePhone || ''}
                onChange={(e) => updateContact(index, 'homePhone', e.target.value)} placeholder="Home phone" />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Mobile Phone</label>
              <input type="tel" className="form-control" value={contact.mobilePhone || ''}
                onChange={(e) => updateContact(index, 'mobilePhone', e.target.value)} placeholder="Mobile phone" />
            </div>
          </div>
        </div>
      ))}

      {error && <div className="error-text">{error}</div>}
      <button type="button" className="btn btn-secondary btn-sm" onClick={addContact}>
        <i className="fas fa-plus"></i> Add Another Contact
      </button>
    </div>
  );
}

export default ContactList;
